export const environment = {
  realtimeApiURL: 'https://back2.devarea.app/gsat/v1.0/realtime/',
  envName: 'dev',
  production: false,
  googleClientId: '758724306366-e35q76sgl2c0mvv0mfoa8fldam6arm2n.apps.googleusercontent.com',
  googleSsoEndpoint: 'customerAccess/sso/google',
  microsoftClientId: '5ad48451-3db0-46d9-adc0-f68d2b5cb50b',
  microsoftAuthority: 'https://login.microsoftonline.com/common',
  microsoftSsoEndpoint: 'customerAccess/sso/microsoft',
  googleMapsApiKey: '',
  paypalClientId: 'Ac8g0f5bXr_FwR9d2SoS6hZFOEb13NHmnpV74pk1Tg67_pmwdJk6KCzt36OL2KB1lVUlX5nH8dkOu4H2',
  apiURL: 'https://back2.devarea.app/customerPortal/v1.0/',
  oauth: {
    host: 'back2.devarea.app',
    https: true,
    client_id: 'mbasebackoffice'
  },
  communication: {
    https: true
  }
};
